// extracted by mini-css-extract-plugin
module.exports = {"searchDropdownOverlay":"DropdownOverlay_searchDropdownOverlay__eB6TZ"};